export var uiAngleRight = [
    'M9.66 8.2L6.9 10.92C6.79 11.03 6.61 11.03 6.5 10.92L6.34 10.75C6.23 10.64 6.23 10.46 6.34 10.35L8.73 8L6.34 5.65C6.23 5.54 6.23 5.36 6.34 5.25L6.51 5.08C6.62 4.97 6.79 4.97 6.9 5.08L9.66 7.8C9.77 7.91 9.77 8.09 9.66 8.2Z',
];
